import axios from 'axios';

class ZipCodeService {
  static getZipCodeInfo(zipCode) {
    return axios.get(`${process.env.VUE_APP_URL_API_ZIP_CODE}?q=${zipCode}`);
  }
}

export default ZipCodeService;
